import React from 'react';
import styled from 'styled-components';
import GithubIcon from '@material-ui/icons/GitHub';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import { SpotlightThree } from '../Components/Home/SpotlightThree';
import image from '../img/Sr-Full-stack-developer.png';

export const Home = () => {
  return (
    <HomeStyled>
      <SpotlightThree />
      <div className='typography'>
        <h1
          className='animate__fadeInLeftBig'
          style={{ marginBottom: '-1rem' }}
        >
          Hi, I'm Juanma Rodriguez,
        </h1>
        <div className='animate__fadeInLeftBig'>
          <img className='avatar' src={image} alt='avatar' />
        </div>
        <div className='icons'>
          <a
            href='https://github.com/J-MRodriguez'
            className='icon i-github'
            target='_blank'
            rel='noreferrer'
          >
            <GithubIcon />
          </a>
          <a
            href='https://www.linkedin.com/in/juan-marcelo-rodriguez-793bb721a/'
            className='icon i-linkedIn'
            target='_blank'
            rel='noreferrer'
          >
            <LinkedInIcon />
          </a>
        </div>
      </div>
    </HomeStyled>
  );
};

const HomeStyled = styled.header`
  width: 100%;
  height: 100vh;
  position: relative;
  .avatar {
    width: 50%;
    margin-top: 1rem;
  }

  .animate__fadeInLeftBig {
    animation: fadeInLeftBig;
    animation-duration: 2s;
  }

  .typography {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    width: 80%;
    h1 {
      text-shadow: 2px 2px 2px #000;
    }

    .spans {
      font-size: 2rem;
      font-weight: 600;
    }

    p {
      margin-top: 1rem;
      margin-bottom: 1rem;
    }
    h3 {
      font-size: 1.5rem;
      margin-bottom: 1rem;
    }

    .icons {
      display: flex;
      justify-content: center;
      margin-top: 1rem;
      .icon {
        border: 2px solid var(--border-color);
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        transition: all 0.4s ease-in-out;
        cursor: pointer;
        &:hover {
          border: 2px solid #000;
          color: #000;
        }
        &:not(:last-child) {
          margin-right: 1rem;
        }
        svg {
          margin: 0.5rem;
        }
      }
      .i-linkedIn {
        &:hover {
          border: 2px solid #0077b5;
          color: #0077b5;
        }
      }
      .i-github {
        &:hover {
          border: 2px solid #5f4687;
          color: #5f4687;
        }
      }
    }

    @media (max-width: 768px) {
      .typography {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        width: 100%;
      }
      h1 {
        font-size: 1.7rem;
        text-shadow: 1px 1px 2px #000;
      }
      .avatar {
        width: 95%;
      }
    }
  }
`;
